// src/frontend/pages/Room.jsx
import React from 'react';
import ShareLink from '../components/room/ShareLink';
import UserList from '../components/room/UserList';
import EditorSimple from '../components/room/EditorSimple';
import FileList from '../components/room/FileList'; // ← neu

export default function Room({theme, toggleTheme}) {
    return (
        <div className="flex-1 px-4 py-8 max-w-7xl mx-auto w-full">
            <div className="grid lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 space-y-8">
                    <ShareLink/>
                    <div className="grid md:grid-cols-2 gap-8">
                        <EditorSimple/>
                        <FileList/>
                    </div>
                </div>
                <UserList/>
            </div>
        </div>
    );
}